import React, { useState } from 'react'
import {
  ButtonBase,
  DialogContent,
  makeStyles,
  Typography
} from '@material-ui/core'
import { parseJson } from 'lib/utils'
import { Modal, ModalTitle } from 'asterX-UI/Modals'
import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UI'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'

const useStyles = makeStyles(theme => ({
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  rootBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  btnContainer: {
    display: 'flex',
    gap: 16,
    direction: 'row'
  },
  titleBox: {
    display: 'flex',
    gap: 10,
    justifyContent: 'space-between'
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    padding: 5,
    gap: 10
  },

  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  heading: {
    fontSize: 14,
    fontWeight: 500,
    color: GRAY_COLORS[700],
    flexShrink: 0
  },
  secondaryHeading2: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexBasis: '20%'
  },
  root: {
    backgroundColor: BASE_COLORS.White,
    borderRadius: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  }
}))

const OneCInfo = ({ title = 'Загрузка РЛ в 1С', listArr = [] }) => {
  const classes = useStyles()
  const regex = new RegExp(String.fromCharCode(65279), 'g')
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(!open)

  const lastElement = listArr?.length > 0 && parseJson(listArr[0]?.response)
  const status = listArr[0]?.responseCode === 'success'

  return (
    <div className={classes.root}>
      <div className={classes.titleBox}>
        <Typography className={classes.heading}>{title}</Typography>
        <div className={classes.btnContainer}>
          {listArr?.length > 1 && (
            <ButtonBase
              style={{
                color: PRIMARY_COLORS[700]
              }}
              size={'small'}
              onClick={handleOpen}
            >
              Посмотреть все
            </ButtonBase>
          )}
        </div>
      </div>

      {lastElement && (
        <div className={classes.card}>
          <div className={classes.row}>
            <FieldInfoNG
              label={'Дата/время'}
              rootStyle={{
                alignItems: 'center'
              }}
              style={{
                fontSize: 12,
                fontWeight: 400
              }}
            >
              {listArr?.[0]?.createdDate
                ? new Date(listArr?.[0]?.createdDate).toLocaleString()
                : 'Нет данных'}
            </FieldInfoNG>

            <ChipStandard
              backgroundColor={status ? SUCCESS_COLORS[50] : ERROR_COLORS[50]}
              color={status ? SUCCESS_COLORS[700] : ERROR_COLORS[700]}
            >
              {status ? 'Успешно' : 'Ошибка'}
            </ChipStandard>
          </div>
          <FieldInfoNG
            label={'Сообщение'}
            rootStyle={{
              alignItems: 'center'
            }}
            style={{
              fontSize: 12,
              fontWeight: 400
            }}
          >
            {lastElement && lastElement.message}
          </FieldInfoNG>
        </div>
      )}
      <Modal
        aria-labelledby="autoEquipment-title"
        open={open}
        maxWidth="md"
        fullWidth
        onClose={handleOpen}
      >
        <ModalTitle id="autoEquipment-title" onClose={handleOpen}>
          {title}
        </ModalTitle>
        <DialogContent>
          <div className={classes.rootBox}>
            {listArr.map((value, index) => {
              try {
                const data =
                  value.response &&
                  JSON.parse(value.response?.toString()?.replace(regex, '')) &&
                  JSON.parse(
                    value.response?.toString()?.replace(regex, '')
                  ).hasOwnProperty('status') &&
                  JSON.parse(value.response?.toString()?.replace(regex, ''))

                const status = data && data.status !== 'fail'

                return (
                  <div key={`rlIn1c_${index}`} className={classes.card}>
                    <div className={classes.row}>
                      <FieldInfoNG
                        label={'Дата/время'}
                        rootStyle={{
                          alignItems: 'center'
                        }}
                        style={{
                          fontSize: 12,
                          fontWeight: 400
                        }}
                      >
                        {value?.createdDate
                          ? new Date(value?.createdDate).toLocaleString()
                          : 'Нет данных'}
                      </FieldInfoNG>

                      <ChipStandard
                        backgroundColor={
                          status ? SUCCESS_COLORS[50] : ERROR_COLORS[50]
                        }
                        color={status ? SUCCESS_COLORS[700] : ERROR_COLORS[700]}
                      >
                        {status ? 'Успешно' : 'Ошибка'}
                      </ChipStandard>
                    </div>
                    <FieldInfoNG
                      label={'Сообщение'}
                      rootStyle={{
                        alignItems: 'flex-start'
                      }}
                      style={{
                        fontSize: 12,
                        fontWeight: 400
                      }}
                    >
                      {data && data.message}
                    </FieldInfoNG>
                  </div>
                )
              } catch (e) {
                console.error(e)
              }
            })}
          </div>
        </DialogContent>
      </Modal>
    </div>
  )
}
export default OneCInfo
OneCInfo.propTypes = {}
